import { Component } from '@angular/core';

@Component({
  selector:'pm-promociones-list',
  templateUrl: './promociones-list.component.html',
  styleUrls: ['./promociones-list.component.sass']
})
export class PromocionesListComponent {
  public showPromociones : boolean  = true;
  public showAddPromocion : boolean  = false;
  public showEditPromocion : boolean  = false;
  public editnumber: number = 0;
}

